import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { writerOrderListSelector } from 'store/Writer/OrderList';
import OrdersStatusTable from 'components/shared/Table/OrdersStatusTable';
import { NON_ATTRUBUTED_ORDERS_COLUMN } from 'utils/Constants';
import { ORDERSTATUS } from 'utils/Constants';

function WriterNonAttributedOrders() {
  const columns = NON_ATTRUBUTED_ORDERS_COLUMN;
  const { t } = useTranslation();

  //select the in progress orders from the orderlist store
  const { nonAttributedCommands, isLoading } = useSelector(
    writerOrderListSelector
  );

  useEffect(() => {
    window.dispatchEvent(new Event('locationchange'));
  }, []);

  return (
    <>
      <OrdersStatusTable
        title={t('Commandes non attribuées')}
        columns={columns}
        orders={nonAttributedCommands}
        isLoading={isLoading}
        isNonAttributed={true}
        orderStatus={ORDERSTATUS.NONATTRIBUTED}
      />
    </>
  );
}

export default WriterNonAttributedOrders;
